
import { defineComponent } from "vue";
import useBreakpoints from "@/composables/useBreakpoints";

export default defineComponent({
  name: "TransactionsEmpty",
  setup() {
    const breakpoints = useBreakpoints();

    return {
      breakpoints,
    };
  },
});
